import {
	DROPS_LIST_MODULE_ID,
} from 'root/src/shared/descriptions/modules/moduleIds'
import { dropEvent } from 'root/src/shared/descriptions/endpoints/recordTypes'
import { dropsEventListType } from 'root/src/shared/constants/moduleTypes'
import { GET_DROP_EVENTS } from 'root/src/shared/descriptions/endpoints/endpointIds'
import { liveEventsKey } from 'root/src/shared/constants/keys'

export default {
	[DROPS_LIST_MODULE_ID]: {
		moduleType: 'list',
		hideEmptyTabs: true,
		listType: dropsEventListType,
		recordType: dropEvent,
		endpointId: [GET_DROP_EVENTS],
		listPayload: {
			section: liveEventsKey,
			pageItemLength: 8,
		},
	},
}
